import {Component, OnInit, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {environment} from "../environments/local/environment";
import {app} from "@microsoft/teams-js";
import {AuthService} from "./services/auth/auth.service";
import {TranslateService} from "@ngx-translate/core";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MatProgressSpinner],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  version = environment.appVersion;
  environment = environment.envName;
  initializationFinished = signal<boolean>(false);

  constructor(private authService: AuthService, private translate: TranslateService) {
  }

  async ngOnInit(): Promise<void> {
    console.log(environment.appVersion);
    console.log(environment.envName);
    try {
      await app.initialize();
      console.log('init: teams')
      let context = await app.getContext(); //use later if needed
      if(context.app.locale.startsWith('en')){
        this.translate.use('en')
        this.translate.setDefaultLang('en');
      }
      console.log('Current Theme: ', context.app.theme);
      console.log('get context: teams')
    }catch (e){
      this.authService.onAuthenticationFailed();
    }
    this.initializationFinished.set(true);
  }
}
